<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-heading">
      <div class="container">
        <div class="heading-content">
          <h1>华胤制造</h1>
        </div>
      </div>
    </div>
    <section>
      <div class="tabs tabs-style-linebox">
        <div class="zznav hidden-xs">
          <ul class="zzitem">
            <li><a @click="forId('gcjs')">工厂介绍</a></li>
            <li><a @click="forId('pzjc')">品质检测</a></li>
            <li><a @click="forId('cpbz')">产品包装</a></li>
            <li><a @click="forId('cpdb')">产品对比</a></li>
          </ul>
        </div>
        <!-- 小滚轮 -->
        <div id="ss_menu">
          <div>
            <i
              ><a @click="forId('gcjs')">工厂<br />介绍</a></i
            >
          </div>
          <div>
            <i
              ><a @click="forId('pzjc')">品质<br />检测</a></i
            >
          </div>
          <div>
            <i
              ><a @click="forId('cpbz')">产品<br />包装</a></i
            >
          </div>
          <div>
            <i
              ><a @click="forId('cpdb')">产品<br />对比</a></i
            >
          </div>
          <div class="menu">
            <div class="share" id="ss_toggle" data-rot="180">
              <div class="circle"></div>
              <div class="bar"></div>
            </div>
          </div>
        </div>
        <div class="content-wrap">
          <section id="gcjs">
            <!-- 图片 -->
            <div class="top">
              <span class="it-ico">
                <div class="t1">
                  <font class="t2"><strong>工厂介绍</strong></font
                  ><br />ABOUT US
                </div>
              </span>
            </div>
            <br /><br /><br />
            <div class="seboxp">
              <p>
                华胤集团拥有专业的建筑钢结构制造工厂，华胤在江苏省南通市国家级海安经济技术开发区设立钢结构制造工厂。工厂占地面积12.5万平米，生产车间6.3万平米，月产能达到出口产品4000-4500吨以上，同时工厂还拥有符合最新中国环境保护要求的喷涂生产线，这为我们的制造加工提供了稳定的保障。公司秉承华胤钢结构一贯的“持续创新，改善质量，诚信服务”的宗旨，持续为顾客创造更好的服务和提供更优质服务。
              </p>
            </div>

            <div class="seboxTitle">车间介绍</div>
            <section class="page-wrapper effect-1st" id="coidea">
              <!-- COIDEA:demo:grid START -->
              <div class="grid">
                <!-- COIDEA:demo:grid-item START -->
                <div class="grid-item effect-first">
                  <div class="image">
                    <img v-lazy="hyzz1" alt="Lazy-loaded Image" />
                    <div class="overlay"></div>
                  </div>
                  <div class="content">
                    <h2>生产车间<br />面积：28000平方</h2>
                  </div>
                </div>
                <!-- COIDEA:demo:grid-item END -->
              </div>
              <!-- COIDEA:demo:grid END -->
            </section>
            <!-- COIDEA:demo:effect-1st END -->

            <!-- COIDEA:demo:effect-2nd START -->
            <section class="page-wrapper effect-2nd" id="coidea">
              <!-- COIDEA:demo:grid START -->
              <div class="grid">
                <!-- COIDEA:demo:grid-item START -->
                <div class="grid-item effect-second">
                  <div class="image">
                    <img v-lazy="hyzz2" alt="Lazy-loaded Image" />
                    <div class="overlay1"></div>
                    <div class="overlay2"></div>
                    <div class="overlay3"></div>
                  </div>
                  <div class="content">
                    <h2>涂装车间<br />面积：10000平方</h2>
                  </div>
                </div>
                <!-- COIDEA:demo:grid-item END -->
              </div>
              <!-- COIDEA:demo:grid END -->
            </section>
            <!-- COIDEA:demo:effect-2nd END -->

            <!-- COIDEA:demo:effect-3rd START -->
            <section class="page-wrapper effect-3rd" id="coidea">
              <!-- COIDEA:demo:grid START -->
              <div class="grid">
                <!-- COIDEA:demo:grid-item START -->
                <div class="grid-item effect-third">
                  <div class="image">
                    <img v-lazy="hyzz3" alt="Lazy-loaded Image" />
                    <div class="overlay1"></div>
                    <div class="overlay2"></div>
                    <div class="overlay3"></div>
                  </div>
                  <div class="content">
                    <h2>
                      <span>成品堆场</span
                      ><br />面积：15000平方<br />起吊重量：20T<br />起吊高度：8M<br />数量：两台
                    </h2>
                  </div>
                </div>
                <!-- COIDEA:demo:grid-item END -->
              </div>
              <!-- COIDEA:demo:grid END -->
            </section>
            <div class="seboxTitle">设备介绍</div>
            <div class="seboxlist animate__animated animate__fadeIn">
              <div class="row">
                <div class="col-md-3">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz4" alt="Lazy-loaded Image" class="cmn" />
                    <p>机器人焊接</p>
                  </div>
                </div>
                <div class="col-md-9">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz5" alt="Lazy-loaded Image" />
                        <p>喷砂机</p>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="area">
                        <!-- 区域3的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz6" alt="Lazy-loaded Image" />
                        <p>SAW 焊机</p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4" style="padding-left: 0">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz7" alt="Lazy-loaded Image" />
                        <p>数控钻孔机</p>
                      </div>
                    </div>
                    <div class="col-md-8" style="padding-right: 15px">
                      <div class="area">
                        <!-- 区域3的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz8" alt="Lazy-loaded Image" />
                        <p>双极埋弧焊机</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz9" alt="Lazy-loaded Image" class="cmn" />
                    <p>数控等离子型钢切割机</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz10" alt="Lazy-loaded Image" />
                        <p>激光切割机</p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz11" alt="Lazy-loaded Image" />
                        <p>激光切割</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz12" alt="Lazy-loaded Image" />
                    <p>CNC数控钻床</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="area">
                    <!-- 区域2的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz13" alt="Lazy-loaded Image" />
                    <p>环保喷漆房</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz14" alt="Lazy-loaded Image" class="cmn" />
                    <p>组立机</p>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz15" alt="Lazy-loaded Image" class="cmn" />
                    <p>电渣焊</p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz16" alt="Lazy-loaded Image" />
                        <p>材料存储</p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="area">
                        <!-- 区域2的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz17" alt="Lazy-loaded Image" />
                        <p>多门火焰切割机</p>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="area">
                        <!-- 区域3的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz18" alt="Lazy-loaded Image" />
                        <p>数控等离子切割</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 品质检测 -->
          <section id="pzjc">
            <div class="top">
              <span class="it-ico">
                <div class="t1">
                  <font class="t2"><strong>品质检测</strong></font
                  ><br />ABOUT US
                </div>
              </span>
            </div>
            <br /><br /><br />
            <div class="seboxp">
              <p>
                华胤注重严格的制程管理和品质控制，贯穿从原材料到成品的每个制造细节。我们和客户一起努力，使华胤制造的每一支构件都臻于完美。
              </p>
            </div>

            <div class="seboxlist">
              <div class="row">
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz19" alt="Lazy-loaded Image" />
                    <p>BH柱拼装自检</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz20" alt="Lazy-loaded Image" />
                    <p>焊工考试</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz21" alt="Lazy-loaded Image" />
                    <p>甲方检查</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz22" alt="Lazy-loaded Image" />
                    <p>品质复查</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz23" alt="Lazy-loaded Image" />
                    <p>实验室</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz24" alt="Lazy-loaded Image" />
                    <p>原材料堆放</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 产品包装 -->
          <section id="cpbz">
            <div class="top">
              <span class="it-ico">
                <div class="t1">
                  <font class="t2"><strong>产品包装</strong></font
                  ><br />ABOUT US
                </div>
              </span>
            </div>
            <br /><br /><br />
            <div class="seboxp">
              <p>
                为了使客户收到的每一支构件都和刚出厂时一样完美，华胤依据运输的距离、方式以及客户的要求对产品进行包装。优良的包装使得构件在严苛的运输过程中得到保护，这使得我们的产品可以被装运到任何地方。我们的产品曾被运送到美国、日本、欧洲、澳州、韩国、泰国甚至南非、海地、安哥拉等非州地区。
              </p>
            </div>

            <div class="seboxlist">
              <div class="row">
                <div class="col-md-8">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz25" alt="Lazy-loaded Image" class="cmn" />
                    <p>游轮运输</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="area">
                        <!-- 区域1的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz26" alt="Lazy-loaded Image" />
                        <p>小件打包</p>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="area">
                        <!-- 区域1的内容，占据半个屏幕宽度 -->
                        <img v-lazy="hyzz27" alt="Lazy-loaded Image" />
                        <p>散件打包</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz28" alt="Lazy-loaded Image" />
                    <p>木箱打包</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz29" alt="Lazy-loaded Image" />
                    <p>大件打包</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="area">
                    <!-- 区域1的内容，占据半个屏幕宽度 -->
                    <img v-lazy="hyzz30" alt="Lazy-loaded Image" />
                    <p>集箱打包</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 产品对比 -->
          <section id="cpdb">
            <div class="top">
              <span class="it-ico">
                <div class="t1">
                  <font class="t2"><strong>产品特色</strong></font
                  ><br />ABOUT US
                </div>
              </span>
            </div>
            <br /><br /><br />
            <carousel-3d
              :controlsVisible="true"
              :width="cWidth"
              :height="cHeight"
              :display="cNum"
              :space="280"
            >
              <slide
                v-lazy-container="{ selector: 'img' }"
                :index="index"
                v-for="(item, index) in List"
                :key="index"
              >
                <div class="col-md-12 col-xs-12">
                  <h2 class="slideh2">{{ item.title }}</h2>
                  <div class="col-md-6">
                    <img :data-src="item.img1" class="slideImg" alt="" />
                    <p class="slideP">{{ item.txt1 }}</p>
                  </div>
                  <div class="col-md-6">
                    <img :data-src="item.img2" class="slideImg" alt="" />
                    <p class="slideP">{{ item.txt2 }}</p>
                  </div>
                </div>
                <p
                  class="slideP"
                  style="
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%, 0);
                  "
                >
                  第{{ index + 1 }}页/共23页
                </p>
              </slide>
            </carousel-3d>
          </section>
        </div>
        <!-- /content -->
      </div>
      <!-- /tabs -->
    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import ScrollMagic from 'scrollmagic'
import gsap from 'gsap'
import { TweenMax } from 'gsap'
import 'bootstrap/dist/js/bootstrap.js'
export default {
  data() {
    return {
      List: [
        {
          title: '原材料管理',
          img1: require('@/components/img/hyzz/cpdb1.jpg'),
          txt1: '常见问题：原材料随意乱放，不同的材质没有做区分，工人很容易乱拿，乱用。',
          img2: require('@/components/img/hyzz/cpdb1-1.jpg'),
          txt2: '华胤：有合适的库位且材料办法整齐',
        },
        {
          title: '颜色及条码管理',
          img1: require('@/components/img/hyzz/cpdb2.jpg'),
          txt1: '常见问题：材料无标示，制作上容易出错。',
          img2: require('@/components/img/hyzz/cpdb2-1.jpg'),
          txt2: '华胤：不同的钢种用颜色刷涂做区分',
        },
        {
          title: '原材料供应商',
          img1: require('@/components/img/hyzz/cpdb3.jpg'),
          txt1: '常见问题：选择没有任何标识的钢厂，属于“三无”产品。',
          img2: require('@/components/img/hyzz/cpdb3-1.jpg'),
          txt2: '华胤：选择国内大品牌钢厂：首钢，马钢等。',
        },
        {
          title: '钢板切割质量',
          img1: require('@/components/img/hyzz/cpdb4.jpg'),
          txt1: '常见问题：切割面凹凸不平,有锯齿缺陷,外观质量非常差。',
          img2: require('@/components/img/hyzz/cpdb4-1.jpg'),
          txt2: '华胤：CNC切割，切割表面质量良好。',
        },
        {
          title: '自由边倒角打磨',
          img1: require('@/components/img/hyzz/cpdb5.jpg'),
          txt1: '常见问题：自由未做倒角打磨,有毛刺未去除。',
          img2: require('@/components/img/hyzz/cpdb5-1.jpg'),
          txt2: '华胤：所有切割面及自由边都倒角打磨。',
        },
        {
          title: '引板弧',
          img1: require('@/components/img/hyzz/cpdb6.jpg'),
          txt1: '常见问题：没有装引弧板。',
          img2: require('@/components/img/hyzz/cpdb6-1.jpg'),
          txt2: '华胤：BH埋弧焊缝装引弧板。',
        },
        {
          title: '倒角',
          img1: require('@/components/img/hyzz/cpdb7.jpg'),
          txt1: '常见问题：螺栓孔有毛刺,影响油漆的附着力',
          img2: require('@/components/img/hyzz/cpdb7-1.jpg'),
          txt2: '华胤：所有螺栓孔都倒角打磨',
        },
        {
          title: '过焊孔倒角',
          img1: require('@/components/img/hyzz/cpdb8.jpg'),
          txt1: '常见问题：不开过焊孔， 三条焊缝交叉处成型非常差，有弧坑缺陷',
          img2: require('@/components/img/hyzz/cpdb8-1.jpg'),
          txt2: '华胤：主要焊缝交叉处有开过焊孔，防止产生应力集中，并且包角焊缝合格。',
        },
        {
          title: '定位焊',
          img1: require('@/components/img/hyzz/cpdb9.jpg'),
          txt1: '常见问题：没有工艺要求， 随意进行点焊.',
          img2: require('@/components/img/hyzz/cpdb9-1.jpg'),
          txt2: '华胤：有工艺要求进行点焊固定，长度要求100~150，间距300~400。',
        },
        {
          title: '埋弧焊',
          img1: require('@/components/img/hyzz/cpdb10.jpg'),
          txt1: '常见问题：焊角大小不均匀，焊道与母材之间未圆滑过渡、有效熔合',
          img2: require('@/components/img/hyzz/cpdb10-1.jpg'),
          txt2: '华胤：焊缝圆滑过渡，外观非常美观，没有任何焊缝缺陷。',
        },
        {
          title: '焊缝内部剖视',
          img1: require('@/components/img/hyzz/cpdb11.jpg'),
          txt1: '常见问题：焊缝内部剖示后,没有熔合。',
          img2: require('@/components/img/hyzz/cpdb11-1.jpg'),
          txt2: '华胤：焊缝内部剖示后，完全熔合',
        },
        {
          title: '钢构矫正',
          img1: require('@/components/img/hyzz/cpdb12.jpg'),
          txt1: '常见问题：焊接后扭曲变形，不做矫正处理。',
          img2: require('@/components/img/hyzz/cpdb12-1.jpg'),
          txt2: '华胤：矫正后符合规范要求。',
        },
        {
          title: '切割',
          img1: require('@/components/img/hyzz/cpdb13.jpg'),
          txt1: '常见问题：手工切割不平直，割纹深，有渣未清除。',
          img2: require('@/components/img/hyzz/cpdb13-1.jpg'),
          txt2: '华胤：机器切割平直光滑，无缺陷。',
        },
        {
          title: '平台梁制作',
          img1: require('@/components/img/hyzz/cpdb14.jpg'),
          txt1: '常见问题：采用手工切割，没有R角。',
          img2: require('@/components/img/hyzz/cpdb14-1.jpg'),
          txt2: '华胤：外露R角圆滑过渡。',
        },
        {
          title: '埋弧自动焊（SAW）',
          img1: require('@/components/img/hyzz/cpdb15.jpg'),
          txt1: '常见问题：国内埋弧焊机焊出来质量很差。',
          img2: require('@/components/img/hyzz/cpdb15-1.jpg'),
          txt2: '华胤：进口埋弧焊机很先进，焊出来构建质量很好',
        },
        {
          title: '破口面切割',
          img1: require('@/components/img/hyzz/cpdb16.jpg'),
          txt1: '常见问题：切割面不平直，有缺口。',
          img2: require('@/components/img/hyzz/cpdb16-1.jpg'),
          txt2: '华胤：切割面平整，光滑。',
        },
        {
          title: '拼装工艺',
          img1: require('@/components/img/hyzz/cpdb17.jpg'),
          txt1: '常见问题：没有拼装工艺要求。',
          img2: require('@/components/img/hyzz/cpdb17-1.jpg'),
          txt2: '华胤：按制作工艺开坡口，打磨拼装',
        },
        {
          title: 'SMAW焊缝',
          img1: require('@/components/img/hyzz/cpdb18.jpg'),
          txt1: '常见问题：焊缝粗糙，成型很差。',
          img2: require('@/components/img/hyzz/cpdb18-1.jpg'),
          txt2: '华胤：焊缝圆滑、整齐。',
        },
        {
          title: '多道焊',
          img1: require('@/components/img/hyzz/cpdb19.jpg'),
          txt1: '常见问题：焊道与焊道之间未融合。',
          img2: require('@/components/img/hyzz/cpdb19-1.jpg'),
          txt2: '华胤：焊道与焊道之间光滑整齐。',
        },
        {
          title: 'GMAW焊接',
          img1: require('@/components/img/hyzz/cpdb20.jpg'),
          txt1: '常见问题：焊缝成型粗糙，外观有缺陷。',
          img2: require('@/components/img/hyzz/cpdb20-1.jpg'),
          txt2: '华胤：焊缝成型美观圆滑过渡。',
        },
        {
          title: '抛丸除锈',
          img1: require('@/components/img/hyzz/cpdb21.jpg'),
          txt1: '常见问题：除锈等级不彻底。',
          img2: require('@/components/img/hyzz/cpdb21-1.jpg'),
          txt2: '华胤：除锈等级达到Sa2 ½。',
        },
        {
          title: '喷漆质量',
          img1: require('@/components/img/hyzz/cpdb22.jpg'),
          txt1: '常见问题：油漆多处碰伤,油漆厚度不均匀。',
          img2: require('@/components/img/hyzz/cpdb22-1.jpg'),
          txt2: '	华胤：油漆涂层均匀,外观无缺陷。',
        },
        {
          title: '摩擦面贴纸保护',
          img1: require('@/components/img/hyzz/cpdb23.jpg'),
          txt1: '常见问题：摩擦面不贴纸,涂漆。',
          img2: require('@/components/img/hyzz/cpdb23-1.jpg'),
          txt2: '华胤：摩擦面按规范贴纸。',
        },
      ],
      hyzz1: require('@/components/img/hyzz/cjjs1.png'),
      hyzz2: require('@/components/img/hyzz/cjjs2.png'),
      hyzz3: require('@/components/img/hyzz/cjjs3.png'),
      hyzz4: require('@/components/img/hyzz/sbjs1.png'),
      hyzz5: require('@/components/img/hyzz/sbjs2.png'),
      hyzz6: require('@/components/img/hyzz/sbjs3.jpg'),
      hyzz7: require('@/components/img/hyzz/sbjs4.jpg'),
      hyzz8: require('@/components/img/hyzz/sbjs5.jpg'),
      hyzz9: require('@/components/img/hyzz/sbjs6.jpg'),
      hyzz10: require('@/components/img/hyzz/sbjs7.png'),
      hyzz11: require('@/components/img/hyzz/sbjs8.jpg'),
      hyzz12: require('@/components/img/hyzz/sbjs9.jpg'),
      hyzz13: require('@/components/img/hyzz/sbjs10.png'),
      hyzz14: require('@/components/img/hyzz/sbjs11.jpg'),
      hyzz15: require('@/components/img/hyzz/sbjs12.jpg'),
      hyzz16: require('@/components/img/hyzz/sbjs13.jpg'),
      hyzz17: require('@/components/img/hyzz/sbjs14.jpg'),
      hyzz18: require('@/components/img/hyzz/sbjs15.jpg'),
      hyzz19: require('@/components/img/hyzz/pzjc1.jpg'),
      hyzz20: require('@/components/img/hyzz/pzjc2.jpg'),
      hyzz21: require('@/components/img/hyzz/pzjc3.jpg'),
      hyzz22: require('@/components/img/hyzz/pzjc4.jpg'),
      hyzz23: require('@/components/img/hyzz/pzjc5.jpg'),
      hyzz24: require('@/components/img/hyzz/pzjc6.jpg'),
      hyzz25: require('@/components/img/hyzz/cpbz1.jpg'),
      hyzz26: require('@/components/img/hyzz/cpbz2.jpg'),
      hyzz27: require('@/components/img/hyzz/cpbz3.jpg'),
      hyzz28: require('@/components/img/hyzz/cpbz4.jpg'),
      hyzz29: require('@/components/img/hyzz/cpbz5.jpg'),
      hyzz30: require('@/components/img/hyzz/cpbz6.jpg'),
    }
  },
  mounted() {
    // 获取高度
    window.onresize = () => {
      this.changeHeight()
    }
    // 图片

    $(document).ready(function () {
      // Controller
      var controller = new ScrollMagic.Controller({
        loglevel: 3,
      })

      // Set Variables
      TweenMax.set('.grid-item .image', {
        perspective: 500,
      })
      TweenMax.set('.grid-item .image .overlay', {
        z: 150,
      })
      TweenMax.set('.grid-item .image .content h2', {
        z: 151,
        autoAlpha: 0,
      })

      // grid-item with effect-first
      var timelineEffectFirst = new gsap.timeline({
        paused: true,
      })
      timelineEffectFirst
        .fromTo(
          '.effect-first .image .overlay',
          1,
          {
            skewX: -10,
            scale: 1.15,
          },
          {
            delay: 1,
            skewX: 20,
            xPercent: 85,
            transformOrigin: '0% 100%',
          }
        )
        .from(
          '.effect-first .image img',
          1,
          {
            z: 100,
            transformOrigin: '50% 0%',
          },
          '-=1'
        )
        .fromTo(
          '.effect-first .content > h2',
          0.75,
          {
            autoAlpha: 0,
            x: -128,
          },
          {
            autoAlpha: 1,
            x: 0,
          },
          '-=0.75'
        )
      new ScrollMagic.Scene({
        triggerElement: '.effect-first',
        triggerHook: 0.8,
        offset: 60,
      })
        .addTo(controller)
        .setTween(timelineEffectFirst.play())

      // grid-item with effect-second
      var timelineEffectSecond = new gsap.timeline({
        paused: true,
      })
      timelineEffectSecond
        .fromTo(
          '.effect-second .image .overlay1',
          1,
          {
            scale: 1.15,
          },
          {
            xPercent: 90,
          }
        )
        .fromTo(
          '.effect-second .image .overlay2',
          1,
          {
            scale: 1.15,
          },
          {
            xPercent: 90,
          },
          '-=0.85'
        )
        .fromTo(
          '.effect-second .image .overlay3',
          1,
          {
            scale: 1.15,
          },
          {
            xPercent: 90,
          },
          '-=0.75'
        )
        .from(
          '.effect-second .image img',
          1,
          {
            z: 100,
            transformOrigin: '50% 0%',
          },
          '-=1.25'
        )
        .fromTo(
          '.effect-second .content > h2',
          0.75,
          {
            autoAlpha: 0,
            x: -128,
          },
          {
            autoAlpha: 1,
            x: 0,
          },
          '-=0.75'
        )
      new ScrollMagic.Scene({
        triggerElement: '.effect-second',
        triggerHook: 0.8,
      })
        .addTo(controller)
        .setTween(timelineEffectSecond.play())

      // grid-item with effect-third
      var timelineEffectThird = new gsap.timeline({
        paused: true,
      })
      timelineEffectThird
        .fromTo(
          '.effect-third .image .overlay1',
          1,
          {
            scale: 1.15,
          },
          {
            yPercent: 100,
          }
        )
        .fromTo(
          '.effect-third .image .overlay2',
          1,
          {
            scale: 1.15,
          },
          {
            yPercent: 100,
          },
          '-=0.85'
        )
        .fromTo(
          '.effect-third .image .overlay3',
          1,
          {
            scale: 1.15,
          },
          {
            yPercent: 100,
          },
          '-=0.75'
        )
        .from(
          '.effect-third .image img',
          1,
          {
            z: 100,
            transformOrigin: '50% 0%',
          },
          '-=1.25'
        )
        .fromTo(
          '.effect-third .content > h2',
          0.75,
          {
            autoAlpha: 0,
            y: -128,
          },
          {
            autoAlpha: 1,
            y: 0,
          },
          '-=0.75'
        )
      new ScrollMagic.Scene({
        triggerElement: '.effect-third',
        triggerHook: 0.8,
      })
        .addTo(controller)
        .setTween(timelineEffectThird.play())
    })
  },
  methods: {
    // 调用全局方法，滚动指定id
    forId(tId) {
      console.log(tId);
      this.$store.dispatch('toID', tId);
    },
    //根据电脑分辨率设置轮播图宽度
    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth = 1400
        this.cHeight = 800
        this.cNum = 5
      } else if (document.body.clientWidth >= 768) {
        this.cWidth = 1200
        this.cHeight = 600
        this.cNum = 3
      } else if (document.body.clientWidth < 768) {
        this.cWidth = 1200
        this.cHeight = 1700
        this.cNum = 3
      }
    },
  },
  created() {
    this.changeHeight()
  },
}
</script>

<style scoped>
@import url('./css/tabs.css');
@import url('./css/tabstyles.css');
@import url('./css/fontAwesome.css');
#gcjs,
#pzjc,
#cpbz,
#cpdb {
  margin-top: -83px;
  padding-top: 83px;
}
.seboxp {
  padding: 5px;
}
/* 荣誉图片注释设置 */
.slideImg {
  width: 100%;
  height: 450px;
  margin-bottom: -30px;
  padding-bottom: 30px;
}
.slideh2 {
  text-align: center;
  font-size: 30px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.slideP {
  padding-top: 10px;
  text-align: center;
  color: #000;
  font-size: 16px;
  line-height: 30px;
}
@media (max-width: 768px) {
  .slideImg {
    height: 170px;
  }
  .slideP {
    padding-top: 5px;
    font-size: 13px;
    line-height: 24px;
  }
}
.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
/* 头部 */
.page-heading {
  background-image: url(@/components/img/hyzz/top5.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  text-align: center;
}

.page-heading .heading-content h1 {
  font-size: 32px;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 1px;
  background-color: rgba(5, 5, 5, 0.9);
  display: inline-block;
  margin-bottom: 0;
  margin-top: 220px;
  padding: 20px 60px;
}

.page-heading .heading-content em {
  font-style: normal;
  font-weight: 200;
}
/* 导航栏 */
.zznav {
  position: relative;
  width: 100%;
  height: 65px;
  background-color: #262626;
}
.zzitem {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  display: flex; /*弹性布局，使li排成一行*/
  z-index: 99;
}
.zzitem li {
  list-style: none;
}
.zzitem li a {
  position: relative;
  display: block;
  padding: 10px 20px;
  margin: 0 10px;
  text-decoration: none;
  text-transform: uppercase; /*将字符转为大写*/
  color: #8f8c8c;
  font-weight: bold;
  font-size: 22px;
  cursor: pointer;
  /* transition: 0.5s; */
}
.zzitem li a:hover {
  color: #fff;
}
.zzitem li a:before {
  /*a:before，在a链接之前添加新内容，这里添加上下边框*/
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top: 2px solid #a56c41;
  border-bottom: 2px solid #a56c41;
  transform: scaleY(2); /*拉长边框两倍*/
  opacity: 0; /*边距不显示*/
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:before {
  transform: scaleY(1); /*拉长边框两倍*/
  opacity: 1;
}
.zzitem li a:after {
  content: '';
  position: absolute;
  top: 1px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #a56c41;
  transform: scale(0);
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:after {
  transform: scale(1);
}
/* 小滚轮 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  display: block;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #a56c41;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 12px;
  text-align: center;
  background: #a56c41;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #ed9048;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -160px;
}

#ss_menu div:nth-child(2) {
  top: -80px;
  left: -138.56406px;
}

#ss_menu div:nth-child(3) {
  top: -138.56406px;
  left: -80px;
}

#ss_menu div:nth-child(4) {
  top: -160px;
  left: 0px;
}
/* 图片 */
.seboxlist {
  margin: 10px;
  padding: 30px;
  border: solid 1px #000;
  box-shadow: 10px 10px 5px #888888;
}
.row .area img {
  width: 100%;
  height: 224px;
}
.row .area .cmn {
  height: 500px;
}
/* 自定义 */
.seboxTitle {
  font-size: 35px;
  font-weight: 500;
  margin-top: 40px;
}
@media screen and (max-width: 768px) {
  .tabs {
    font-size: 1.75em;
  }
  .seboxTitle {
    font-size: 30px !important;
  }
  .seboxlist {
    margin: 5px;
    padding: 5px;
  }
  .row .area .cmn {
    height: 224px !important;
  }
  .row .area p {
    font-size: 15px;
  }
}
/* 小标题 */
.top .it-ico {
  margin-top: 5px;
  height: 65px;
  border-bottom: 1px #990000 solid;
  background: url(@/components/img/hyzz/titleico.gif) no-repeat left center;
  float: left;
  display: block;
  font-size: 12px;
  color: #cccccc;
}
.top .it-ico .t1 {
  padding-left: 40px;
  padding-top: 20px;
  color: #cccccc;
  line-height: 20px;
}
.top .it-ico .t1 .t2 {
  font-size: 30px;
  color: #333333;
  font-family: '微软雅黑';
}
/* 图片动画 */
body section#coidea {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  height: 100vh;
  overflow: hidden;
  padding: 20px;
}

body section#coidea .grid {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto;
  overflow: hidden;
}

body section#coidea .grid .grid-item {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  height: 100vh;
  overflow: hidden;
  padding: 32px 0;
}

body section#coidea .grid .grid-item .image {
  position: relative;
  display: block;
  width: 90%;
  /* max-width: 640px; */
  height: auto;
  overflow: hidden;
  float: left;
}

body section#coidea .grid .grid-item .image img {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  overflow: hidden;
}

body section#coidea .grid .grid-item .content {
  position: absolute;
  display: block;
  width: 100%;
  height: auto;
  padding-left: 60vw;
  overflow: hidden;
  float: left;
}

body section#coidea .grid .grid-item .content h2 {
  /* text-transform: uppercase; */
  letter-spacing: 2px;
  opacity: 0;
}

/* effect-first */

body section#coidea.effect-1st {
  background: #121212;
}

body section#coidea.effect-1st .grid .grid-item .image .overlay {
  background-color: #121212;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

body section#coidea.effect-1st .grid .grid-item .content h2 {
  font-size: 40px;
  line-height: 50px;
  padding: 32px 0;
  color: #f8f8f8;
  text-shadow: 0px 7px 15px #121212;
  background-color: #a56c41;
  font-family: '等线Light';
}
body section#coidea.effect-1st .grid .grid-item .content h2 {
  font-size: 50px;
  line-height: 100px;
}

/* effect-second */

body section#coidea.effect-2nd {
  background: #f8f8f8;
}

body section#coidea.effect-2nd .grid .grid-item .image .overlay1 {
  background-color: #f8f8f8;
  position: absolute;
  width: 100%;
  height: 33.3333%;
  left: 0;
  top: 0;
}

body section#coidea.effect-2nd .grid .grid-item .image .overlay2 {
  background-color: #f8f8f8;
  position: absolute;
  width: 100%;
  height: 33.3333%;
  left: 0;
  top: 33.3333%;
}

body section#coidea.effect-2nd .grid .grid-item .image .overlay3 {
  background-color: #f8f8f8;
  position: absolute;
  width: 100%;
  height: 33.3333%;
  left: 0;
  top: 66.6666%;
}

body section#coidea.effect-2nd .grid .grid-item .content h2 {
  font-size: 40px;
  line-height: 50px;
  padding: 32px 0;
  color: #121212;
  text-shadow: 0px 7px 15px rgba(165, 108, 65, 0.5);
  background-color: #f7ead7;
  font-family: '等线Light';
}
body section#coidea.effect-2nd .grid .grid-item .content h2 {
  font-size: 50px;
  line-height: 100px;
}
/* effect-third */

body section#coidea.effect-3rd {
  background: #121212;
}

body section#coidea.effect-3rd .grid .grid-item .image .overlay1 {
  background-color: #121212;
  position: absolute;
  width: 33.3333%;
  height: 100%;
  left: 0;
  top: 0;
}

body section#coidea.effect-3rd .grid .grid-item .image .overlay2 {
  background-color: #121212;
  position: absolute;
  width: 33.3333%;
  height: 100%;
  left: 33.3333%;
  top: 0;
}

body section#coidea.effect-3rd .grid .grid-item .image .overlay3 {
  background-color: #121212;
  position: absolute;
  width: 33.3333%;
  height: 100%;
  left: 66.6666%;
  top: 0;
}

body section#coidea.effect-3rd .grid .grid-item .content h2 {
  font-size: 30px;
  line-height: 40px;
  padding: 32px 0;
  color: #f8f8f8;
  text-shadow: 0px 7px 15px rgba(34, 34, 34, 1);
  background-color: #a56c41;
  font-family: '等线Light';
}
body section#coidea.effect-3rd .grid .grid-item .content h2 span {
  font-size: 50px;
  line-height: 100px;
}
/* effect-fourth */

body section#coidea.effect-4th {
  background: #f8f8f8;
}

body section#coidea.effect-4th .grid .grid-item .image .overlay1 {
  background-color: #f8f8f8;
  position: absolute;
  width: 100%;
  height: 100%;
  left: -50%;
  top: -50%;
}

body section#coidea.effect-4th .grid .grid-item .content h2 {
  font-size: 64px;
  line-height: 72px;
  padding-top: 32px;
  color: #121212;
  text-shadow: 0px 7px 15px rgba(34, 34, 34, 0.15);
}

@media screen and (max-width: 992px) {
  body section#coidea .grid .grid-item .image img {
    height: 40vh;
  }
  body section#coidea .grid .grid-item {
    padding: 0 !important;
  }
  body section#coidea {
    height: auto;
    padding: 0;
  }
  body section#coidea .grid {
    width: 100% !important;
    padding: 10px;
  }
  body section#coidea .grid .grid-item {
    height: auto;
  }
  body section#coidea .grid .grid-item .image {
    max-width: 100%;
    max-width: calc(100% - 32px) !important;
  }
  body section#coidea .grid .grid-item .content {
    padding-left: 160px !important;
  }
  body section#coidea .grid .grid-item .content h2 {
    font-size: 16px !important;
    line-height: 20px !important;
    padding: 10px 0 !important;
  }
  body section#coidea .grid .grid-item .content h2 span {
    font-size: 25px !important;
    line-height: 50px !important;
  }
  body section#coidea.effect-3rd .grid .grid-item .content h2 {
    font-size: 14px !important;
    line-height: 14px !important;
  }
  /* body section#coidea.effect-4th {
      height: 150vh;
  } */
}
/* 手风琴 */
a:hover,
a:focus {
  text-decoration: none;
  outline: none;
}
#accordion {
  padding-left: 2px;
  padding-right: 8px;
  z-index: 1;
}
#accordion .panel {
  border: none;
  box-shadow: none;
}
#accordion .panel-heading {
  padding: 0;
  border-radius: 0;
  border: none;
}
#accordion .panel-title {
  padding: 0;
}
#accordion .panel-title a {
  display: block;
  font-size: 16px;
  font-weight: bold;
  background: #f7ead7;
  color: #000;
  padding: 15px 25px;
  position: relative;
  margin-left: -24px;
  transition: all 0.6s ease 0s;
}
#accordion .panel-title a.collapsed {
  background: #a56c41;
  color: #fff;
  margin-left: 0;
  transition: all 0.6s ease 0s;
}
#accordion .panel-title a:before {
  content: '';
  border-left: 24px solid #f7ead7;
  border-top: 24px solid transparent;
  border-bottom: 24px solid transparent;
  position: absolute;
  top: 0;
  right: -24px;
  transition: all 0.6s ease 0s;
}
#accordion .panel-title a.collapsed:before {
  border-left-color: #a56c41;
}
#accordion .panel-title a:after {
  content: '\f106';
  position: absolute;
  font-family: 'FontAwesome';
  top: 30%;
  right: 15px;
  font-size: 18px;
  color: #000;
}
#accordion .panel-title a.collapsed:after {
  content: '\f107';
  color: #fff;
}
#accordion .panel-collapse {
  position: relative;
}
#accordion .panel-collapse.in:before {
  content: '';
  border-right: 24px solid #f7c59f;
  border-bottom: 18px solid transparent;
  position: absolute;
  top: 0;
  left: -24px;
}
#accordion .panel-body {
  font-size: 14px;
  color: #333;
  background: #e4e4e4;
  border-top: none;
  z-index: 1;
  padding: 15px 0 !important;
}
#accordion .panel-body p {
  font-size: large;
}
#accordion .panel-body img {
  width: 100%;
  height: 470px;
}
@media screen and (max-width: 768px) {
  .content-wrap section {
    margin-top: 10px;
  }
  .seboxp p {
    font-size: 15px;
  }
  #accordion .panel-body img {
    width: 100%;
    height: 150px;
  }
  #accordion .panel-body p {
    font-size: 14px;
  }
}
@media screen and (min-width: 2000px) {
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .zzitem li a {
    margin: 0 50px;
    font-size: 25px;
  }
  .seboxp p {
    font-size: 30px;
  }
  .seboxTitle {
    font-size: 40px;
  }
  body section#coidea.effect-1st .grid .grid-item .content h2 {
    font-size: 60px;
    line-height: 110px;
  }
  body section#coidea.effect-2nd .grid .grid-item .content h2 {
    font-size: 60px;
    line-height: 110px;
  }
  body section#coidea.effect-3rd .grid .grid-item .content h2 span {
    font-size: 60px;
    line-height: 110px;
  }
  body section#coidea.effect-3rd .grid .grid-item .content h2 {
    font-size: 40px;
    line-height: 50px;
  }
  .row .area .cmn {
    height: 706px;
  }
  .row .area img {
    height: 330px;
  }
  .slideh2 {
    font-size: 40px;
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .slideImg {
    height: 500px;
  }
  .slideP {
    font-size: 25px;
    line-height: 35px;
    padding-top: 20px;
  }
}
</style>
